import apiUtils from './ApiUtils'

/**
 * js 调ios native
 * @param {*} name // 方法名
 * @param {*} iosParam // 参数
 * @param {*} defaultValue// 出错时默认的返回值
 */
const iosPostMessage = (() => {
  const channelArray = []
  let h5PostId = 0
  return (name, iosParam, defaultValue = null) => {
    if (typeof iosParam !== 'object') {
      console.error('ios post message 必须为对象形式！')
      return Promise.resolve(defaultValue)
    }
    try {
      h5PostId += 1
      const channel = new MessageChannel()
      channelArray.push({ h5PostId, channel })
      window.nativeCallBack = function (nativeValue) {
        const { h5PostId: iosCbPostId } = nativeValue
        const cbChannel = channelArray.find(item => parseInt(item.h5PostId) === parseInt(iosCbPostId))
        if (cbChannel.channel) {
          cbChannel.channel.port1.postMessage(nativeValue)
        } else {
          console.error('can not find channel 1')
        }
      }
      iosParam.h5PostId = h5PostId
      window.webkit.messageHandlers[name].postMessage(JSON.stringify(iosParam))
      return new Promise((resolve, reject) => {
        const postChannel = channelArray.find(item => parseInt(item.h5PostId) === parseInt(h5PostId))
        if (postChannel.channel) {
          postChannel.channel.port2.onmessage = function (e) {
            resolve(e.data)
            const delIndex = channelArray.findIndex(item => parseInt(item.h5PostId) === parseInt(e.data.h5PostId))
            channelArray.splice(delIndex, 1)
            console.log('channel Array remain...', channelArray)
          }
        } else {
          console.error('can not find channel 2')
          return Promise.resolve(defaultValue)
        }
      })
    } catch (err) {
      console.warn('ios err', name, err)
      return Promise.resolve(defaultValue)
    }
  }
})()

// ios
const iOSBridge = {

  // 请求参数
  async getQueryParam () {
    const queryParam = await iosPostMessage('getQueryParam', {}, {})
    return queryParam
  },

  /**
   * 判断某个接口在当前版本的app是否可用
   * @param {*} API 接口名称
   */
  async canIUse (API) {
    const { iosVer, compareVersion } = apiUtils
    const minVer = iosVer[API]
    if (!minVer) {
      console.error('ios bridge不支持该api', API)
      return false
    }
    try {
      const { version: nowVersion } = await this.getQueryParam()
      return compareVersion(nowVersion, minVer)
    } catch (err) {
      console.error(err)
      return false
    }
  },

  // 获取当前用户信息
  async getUserInfo () {
    const userInfo = await iosPostMessage('getUserInfo', {}, {})
    console.log('ios userinfo', userInfo)
    return userInfo
  },
  // 获取当前国家
  async getLoc () {
    const locInfo = await iosPostMessage('getLoc', {}, {})
    console.log('ios loc info', locInfo)
    let { loc = 'EN' } = locInfo
    if (loc === 'VI') {
      loc = 'VN'
    }
    if (loc === 'IN') {
      loc = 'ID'
    }
    if (loc === 'MS') {
      loc = 'MY'
    }
    return loc
  },

  // 客户端相关信息【版本号等】
  async getClientInfo () {
    const clientInfo = await iosPostMessage('getClientInfo', {}, {})
    return clientInfo
  },

  /**
   * 打点
   * @param {
     *  eventName, //事件显示名
     *  action // 打点事件
     *  ...// 其它信息
     * } point
     */
  analyse (point) {
    console.log('ios->>>>>打点', point)
    return iosPostMessage('analyse', point)
  },
  /**
   * 跳指定用户的 profile
   * @param {string} userId
   */
  jumpToProfile (userId) {
    return iosPostMessage('jumpToProfile', { userId })
  },

  /**
   * 跳指定商品id的支付页
   * @param {string} productId
   */
  jumpToPay (productId) {
    return iosPostMessage('jumpToPay', { productId })
  },

  /**
   * 跳指定语音房
   * @param {string} partyId
   */
  jumpToParty (partyId) {
    return iosPostMessage('jumpToParty', { partyId })
  },

  /**
   * 返回上一页
   */
  backToPrePage () {
    return iosPostMessage('backToPrePage', {})
  }
}

export default iOSBridge
